import * as React from "react";
import { LocationOptionPartsOfDayInputProps, toggleTimeslot } from "./TimeslotInputState";

export function LocationOptionPartsOfDayInput(props: LocationOptionPartsOfDayInputProps) {
  const { availability, selection, updateSelection, date } = props

  const disableMorning = !availability.morning
  const disableAfternoon = !availability.afternoon
  const disableEvening = !availability.evening

  return (
    <fieldset className="zv-form__set">
      <legend className="zv-form__label">Gewenste dagdeel{date ? '' : ' (kies eerst een datum)'}</legend>

      <div className="form__checkbox">
        <input
          type="checkbox"
          name="dayparts"
          id="morning"
          className="form__input--checkbox" 
          disabled={disableMorning}
          checked={selection.morning}
          onChange={_ => updateSelection(toggleTimeslot('morning')(selection))} />
        <label htmlFor="morning" className={`form__label--checkbox${disableMorning ? ' form__label--disabled' : ''}`}>Ochtend <span className="form__extra text--s">(8:00-12:00)</span></label>
      </div>      

      <div className="form__checkbox">
        <input
          type="checkbox"
          name="dayparts"
          id="afternoon"
          className="form__input--checkbox" 
          disabled={disableAfternoon}
          checked={selection.afternoon}
          onChange={_ => updateSelection(toggleTimeslot('afternoon')(selection))} />
        <label htmlFor="afternoon" className={`form__label--checkbox${disableAfternoon ? ' form__label--disabled' : ''}`}>Middag <span className="form__extra text--s">(13:00-17:00)</span></label>
      </div>

      <div className="form__checkbox">
        <input
          type="checkbox"
          name="dayparts"
          id="evening"
          className="form__input--checkbox" 
          disabled={disableEvening}
          checked={selection.evening}
          onChange={_ => updateSelection(toggleTimeslot('evening')(selection))} />
        <label htmlFor="evening" className={`form__label--checkbox${disableEvening ? ' form__label--disabled' : ''}`}>Avond <span className="form__extra text--s">(18:00-22:00)</span></label>
      </div>
    </fieldset>
  )
}
